import { configure, defineRule, Form, Field, ErrorMessage } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import ja from '@vee-validate/i18n/dist/locale/ja.json'
import {alpha,alpha_dash,alpha_num,alpha_spaces,between,confirmed,digits,dimensions,email,ext,image,integer,is,is_not,length,max,max_value,mimes,min,min_value,not_one_of,numeric,one_of,regex,required,size,toTypedSchema,url } from '@vee-validate/rules'

import { setLocale as yupSetLocale } from "yup"; // @vee-validate/i18nのsetLocaleと被るので、別名指定をしています。
import { suggestive } from "yup-locale-ja";
export default defineNuxtPlugin((nuxtApp) => {

/*
Object.keys(AllRules).forEach((rule) => {
    // @ts-ignore
    defineRule(rule, AllRules[rule]);
    // 全ルールを使えるようにする
});
*/
    defineRule('alpha',alpha)
    defineRule('alpha_dash',alpha_dash)
    defineRule('alpha_num',alpha_num)
    defineRule('alpha_spaces',alpha_spaces)
    defineRule('between',between)
    defineRule('confirmed',confirmed)
    defineRule('digits',digits)
    defineRule('dimensions',dimensions)
    defineRule('email',email)
    defineRule('ext',ext)
    defineRule('image',image)
    defineRule('integer',integer)
    defineRule('is',is)
    defineRule('is_not',is_not)
    defineRule('length',length)
    defineRule('max',max)
    defineRule('max_value',max_value)
    defineRule('mimes',mimes)
    defineRule('min',min)
    defineRule('min_value',min_value)
    defineRule('not_one_of',not_one_of)
    defineRule('numeric',numeric)
    defineRule('one_of',one_of)
    defineRule('regex',regex)
    defineRule('required',required)
    defineRule('size',size)
    defineRule('url',url)


  nuxtApp.vueApp.component('ValidationForm', Form)
  nuxtApp.vueApp.component('ValidationField', Field)
  nuxtApp.vueApp.component('ValidationErrorMessage', ErrorMessage)
  configure({
    generateMessage: localize({ ja }),
  })
  setLocale('ja')
   // yupのバリデーションメッセージを日本語にする設定
   yupSetLocale(suggestive);
})
